export const ACCESS_DENIED_MESSAGES = {
  action_denied: "You don't have permission to perform this action. Please contact your organization admin ({email}).",
  message_with_email: 'Access denied, please contact your organization admin ({email}) to get access.',
  headline_with_module: "You don't have access to {module}",
  description: 'Need access? Contact admin to update your permissions.',
  contact_admin: 'Contact admin',
};
